import { useGetAllTagsOfTagType, useGetSideMenuFilterTags } from 'api';
import { filterSideMenuTagsFromTags } from 'reporting/helpers';
import { DAY_CODE_TAG_TYPE } from 'shared';

export const useFetchTags = () => {
    const { data: tags } = useGetAllTagsOfTagType(DAY_CODE_TAG_TYPE);
    const filterSideMenuDisplayTags = filterSideMenuTagsFromTags(tags, '');

    return useGetSideMenuFilterTags(
        'team',
        filterSideMenuDisplayTags?.map((option) => String(option.id)),
        filterSideMenuDisplayTags,
    ).data;
};
